// removed by extract-text-webpack-plugin
module.exports = {"primary":"#1fc2c3","secondary":"#1fc2c3","accent":"#FFFFFF","error":"#FF0000","info":"rgba(0, 0, 0, 0.4)","success":"#4CAF50","warning":"#FFFF00","adminPrimary":"#14298F"};